<template>
  <div>
    <div v-if="isDaily">
      <h1>Intro - Daily System</h1>
      <p>This it a basic limited preview of the new Daily System. 
        None of the data entry features have been wired up, and many of the reports still need work. </p>
      <br>
      <br>
      <h1>Misc</h1>
      <div v-if="isRestartSelected">
        Restarting Server
      </div>
      <div v-else>
        <a :href="$voidHref" v-on:click="restartServer()">Restart Backend Server</a> 
        (experimental, may not work yet)
      </div>
      <br>
      <div v-if="isDevSelected">
        Refresh the Page for this to take effect.
      </div>
      <div v-else>
        <a :href="$voidHref" v-on:click="toggleDevUser()">Toggle Dev Mode</a>
      </div>

    </div>
    <div v-if="isBookkeeping">
      <h1>About</h1>
      <p>In this reporting system are a number of custom reports that pull information from the various location sites and various data sources.</p>
      <p>Some of the reports can be slow due to the number of data sources being pulled, so be patient, especially when looking at a report for an entire month. </p>
    </div>
  </div>
  
</template>
<script>
export default {
  name: 'Intro',
  data: function(){return {
    isRestartSelected: false,
    isDevSelected: false,
    isDev: undefined
  }},
  created (){
    this.isDev = this.$isDev;
  },
  computed:{
    isBookkeeping(){return this.$isBookkeeping},
    isDaily(){return this.$isDaily},
  },
  methods :{
    restartServer : function(){
      this.$axios.get('/dev/restartServer');
      this.isRestartSelected = true
      setTimeout(()=>this.isRestartSelected = false, 7000);
    },
    toggleDevUser (){
      this.isDevSelected = true
      this.isDev = !this.isDev
      localStorage.setItem('isDev', JSON.stringify(this.isDev))
      location.reload();
      // setTimeout(()=>this.isDevSelected = false, 10000);
    }
  }
}
</script>

<style>

</style>
